"use strict";

import Swiper from "swiper";
import { EffectFade, Autoplay, Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".hero-slider").forEach((slider) => {
        const swiper = new Swiper(slider, {
            modules: [EffectFade, Autoplay, Navigation, Pagination],
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            loop: true,
            speed: 1000,
            allowTouchMove: false,
            simulateTouch: false,
            autoplay: {
                disableOnInteraction: false
            },
            navigation: {
                nextEl: slider.querySelector(".arrows-next"),
                prevEl: slider.querySelector(".arrows-prev")
            },
            pagination: {
                el: slider.querySelector(".controls__pagin"),
                clickable: true,
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active"
            },
            on: {
                init: function () {
                    const activeSlide = this.slides[this.activeIndex];
                    if (activeSlide) {
                        const video = activeSlide.querySelector("video");
                        if (video) {
                            video.play().catch(() => {});
                        }
                    }
                },
                slideChangeTransitionStart: function () {
                    const activeSlide = this.slides[this.activeIndex];
                    if (activeSlide) {
                        const activeVideo = activeSlide.querySelector("video");
                        if (activeVideo) {
                            activeVideo.play().catch(() => {});
                        }
                    }
                },
                slideChangeTransitionEnd: function () {
                    const activeSlide = this.slides[this.activeIndex];
                    this.slides.forEach((slide) => {
                        if (slide !== activeSlide) {
                            const video = slide.querySelector("video");
                            if (video) {
                                video.pause();
                                video.currentTime = 0;
                            }
                        }
                    });
                }
            }
        });
    });
});